import { NavLink, Outlet, useNavigate } from 'react-router-dom'
import { logout, useAuth } from '../lib/auth'
import { DrillProvider } from './Drill'

const NAV = [
  { to: '/', label: 'Dashboard', end: true, icon: '◆' },
  { to: '/today', label: 'Today', icon: '➤' },
  { to: '/conversions', label: 'Conversions', icon: '★' },
  { to: '/users', label: 'Users', icon: '◎' },
  { to: '/archives', label: 'Closed accounts', icon: '▣' },
  { to: '/invites', label: 'Invites', icon: '✦' },
  { to: '/tickets', label: 'Tickets', icon: '✎' },
  { to: '/analytics', label: 'Analytics', icon: '▲' },
  { to: '/funnel', label: 'Funnel', icon: '▽' },
  { to: '/leads', label: 'Leads', icon: '◈' },
  { to: '/prospects', label: 'Prospects', icon: '◇' },
  { to: '/emails', label: 'Emails', icon: '✉' },
  { to: '/downloads', label: 'Downloads', icon: '⤓' },
  { to: '/crashes', label: 'Crashes', icon: '✕' },
  { to: '/subscriptions', label: 'Subscriptions', icon: '$' },
  { to: '/marketplace', label: 'Marketplace', icon: '◍' },
  { to: '/organizations', label: 'Organizations', icon: '⬡' },
  { to: '/ai', label: 'AI credits', icon: '✧' },
  { to: '/meetings', label: 'Meetings', icon: '◉' },
  { to: '/conversations', label: 'Conversations', icon: '❝' },
  { to: '/audit', label: 'Audit log', icon: '❑' }
]

export default function Layout() {
  const session = useAuth()
  const navigate = useNavigate()
  return (
    <DrillProvider>
      <div className="min-h-screen flex">
        <aside className="w-60 glass-chrome flex flex-col" style={{ borderRadius: 0, borderLeft: 'none', borderTop: 'none', borderBottom: 'none' }}>
          <div className="px-6 py-5 border-b border-white/5">
            <div className="text-[11px] tracking-[0.3em] text-slate-400 uppercase">Plexii</div>
            <div className="text-sm font-semibold mt-1">Admin console</div>
          </div>
          <nav className="flex-1 px-3 py-4 space-y-1">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors ${
                    isActive ? 'bg-accent/15 text-white border border-accent/30' : 'text-slate-300 hover:bg-white/5 hover:text-white border border-transparent'
                  }`
                }
              >
                <span className="text-accent w-4 text-center">{item.icon}</span>
                {item.label}
              </NavLink>
            ))}
          </nav>
          <div className="px-4 py-4 border-t border-white/5">
            <div className="text-xs text-slate-400">Signed in as</div>
            <div className="text-sm font-medium truncate">{session?.email}</div>
            <div className="text-[10px] uppercase tracking-wider text-accent mt-0.5">{session?.role}</div>
            <button
              onClick={() => {
                void logout().then(() => navigate('/login', { replace: true }))
              }}
              className="btn-ghost mt-3 w-full justify-center"
              style={{ display: 'flex' }}
            >
              Sign out
            </button>
          </div>
        </aside>
        <main className="flex-1 px-10 py-8 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </DrillProvider>
  )
}
